import { map } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import asButton from '../decorator/asButton';
import useItemListState from '../hook/useItemListState';
import useProgressiveLoad from '../hook/useProgressiveLoad';
import CalloutComponent from './Callout';
import './ItemList.css';
import ItemListSelectionComponent from './ItemListSelection';
import { PlaceholderList as PlaceholderListComponent } from './Placeholder';
import StartingLetterComponent from './StartingLetter';

const ItemList = ({ data, prop, type, header, body, updated }) => {
  const [updatedState, setUpdated] = useState(updated);
  const { inViewRef } = useProgressiveLoad(data, prop, updatedState);
  const {
    items,
    shown,
    size,
    hasMore,
    startingWith,
    filter,
    orderBy,
    isDescending,
    toggleSelection,
    allSelected,
    toggleBulkActions,
    countOfSelectedItems,
    getSelection,
    getIsSelected,
    getIsOrdered,
    getOrderAndDirection,
    getWillBeTaxing,
    onItemSelect
  } = useItemListState(data, prop, updated);

  useEffect(() => {
    setUpdated(updated);
  }, [updated]);

  return (
    <>
      <section className="itemList">
        {size > -1 && (
          <StartingLetterComponent
            shown={shown}
            size={size}
            type={type}
            startingWith={startingWith}
            filter={filter}
            disableAllItem={getWillBeTaxing()}
          />
        )}
        {size === 0 && (
          <CalloutComponent
            type="info"
            icon="icon-information-circle"
            title={`Unfortunately, there are no ${type} which match given criteria.`}
            text={`Your ${type} might be filtered by starting letter and/or filter. You can try changing and/or removing the starting letter or filter if you're using one.`}
          />
        )}
        {size > 0 && (
          <ol>
            <li className="header">
              <ItemListSelectionComponent
                id="ALL"
                toggle={toggleSelection || toggleBulkActions}
                allSelected={allSelected}
                shown={shown}
                selectedItems={getSelection()}
                onItemSelect={onItemSelect}
              />
              {header(
                orderBy,
                isDescending,
                getOrderAndDirection,
                getIsOrdered,
                toggleBulkActions,
                countOfSelectedItems,
                shown,
                getWillBeTaxing()
              )}
            </li>
            {map(items, (item) => (
              <li key={item.id} {...asButton(item.id, 'itemListClickItem', undefined, item)}>
                <ItemListSelectionComponent
                  id={item.id}
                  toggle={toggleSelection}
                  shown={shown}
                  selectedItems={getSelection()}
                  onItemSelect={onItemSelect}
                />
                {body(data, item, getIsSelected(item.id, getSelection()))}
              </li>
            ))}
          </ol>
        )}
      </section>
      {hasMore && (
        <PlaceholderListComponent ref={inViewRef} title={`Loading, ${type} please wait ...`} />
      )}
    </>
  );
};

ItemList.propTypes = {
  data: PropTypes.object.isRequired,
  prop: PropTypes.string.isRequired,
  type: PropTypes.string,
  updated: PropTypes.string
};

ItemList.defaultProps = {
  type: undefined,
  updated: undefined
};

export default ItemList;
